/* ==========================================================
   SEÇÃO DE VÍDEOS DO PRODUTO (LAYOUT ZIGZAG)
   - Injetada como sibling logo após o bloco "Tabla de Tallas"
     dentro de .bs-product-story
   ========================================================== */
(function () {
  'use strict';

  var VIDEOS = [
    {
      url: 'https://cdn.shopify.com/videos/c/o/v/23dc8aac9e3a4d34bdd0171b9d05de44.mp4',
      eyebrow: 'Diseño',
      title: 'Hecho para Realzarte',
      copy: 'Cada pieza está pensada para acompañar tu silueta y darte la mayor comodidad. Detalles de malla, acabados cuidados y un tejido premium que crean un look elegante y profundamente femenino — para cualquier ocasión.'
    },
    {
      url: 'https://cdn.shopify.com/videos/c/o/v/f17fae1684ef4b208f3b10dd51991d19.mp4',
      eyebrow: 'Confort',
      title: 'Libertad en Cada Movimiento',
      copy: 'Desde un día en la playa hasta tu próxima escapada, nuestros trajes de baño se mueven contigo. Sin marcar, sin apretar — solo confort, sujeción y estilo en cada momento.'
    }
  ];

  var VIDEO_RATIO = '9/16';
  var AUTOPLAY = true;
  var SECTION_EYEBROW = 'Bella Sirena';
  var SECTION_TITLE = 'Vívelo en Movimiento';
  var SECTION_SUBTITLE = 'Mira cómo nuestras piezas cobran vida.';

  // ===================================================
  function getVideoType(url) {
    if (!url) return null;
    if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube';
    if (/vimeo\.com/i.test(url)) return 'vimeo';
    if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) return 'mp4';
    return null;
  }

  function getYouTubeId(url) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  function getVimeoId(url) {
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
  }

  function buildVideoMedia(url) {
    var type = getVideoType(url);
    var ap = AUTOPLAY ? '1' : '0';

    if (type === 'youtube') {
      var id = getYouTubeId(url);
      if (!id) return null;
      var src = 'https://www.youtube.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=' + ap + '&mute=' + ap + '&loop=1&playlist=' + id + '&controls=0';
      return '<iframe src="' + src + '" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
    }
    if (type === 'vimeo') {
      var vid = getVimeoId(url);
      if (!vid) return null;
      var vsrc = 'https://player.vimeo.com/video/' + vid + '?autoplay=' + ap + '&muted=' + ap + '&loop=1';
      return '<iframe src="' + vsrc + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
    }
    if (type === 'mp4') {
      var attrs = 'controls playsinline preload="metadata"';
      if (AUTOPLAY) attrs += ' autoplay muted loop';
      return '<video ' + attrs + ' src="' + url + '"></video>';
    }
    return null;
  }

  function buildVideoRow(item, index) {
    var media = item.url ? buildVideoMedia(item.url) : '<div class="bs-pv-placeholder"><span style="font-size:48px;color:#c4877a;">▶</span><p style="margin-top:8px;color:#8a827a;">Vídeo ' + (index + 1) + '</p></div>';
    var alignClass = (index % 2 === 0) ? 'bs-pv-row--media-left' : 'bs-pv-row--media-right';

    var eyebrowHTML = item.eyebrow ? '<span class="bs-pv-eyebrow">' + item.eyebrow + '</span>' : '';
    var titleHTML = item.title ? '<h3 class="bs-pv-row-title">' + item.title + '</h3>' : '';
    var copyHTML = item.copy ? '<p class="bs-pv-row-copy">' + item.copy + '</p>' : '';

    return '<article class="bs-pv-row ' + alignClass + '">' +
             '<div class="bs-pv-media-col">' +
               '<div class="bs-pv-media" style="--pv-ratio:' + VIDEO_RATIO + ';">' + media + '</div>' +
             '</div>' +
             '<div class="bs-pv-text-col">' +
               '<div class="bs-pv-text-inner">' +
                 eyebrowHTML +
                 titleHTML +
                 copyHTML +
               '</div>' +
             '</div>' +
           '</article>';
  }

  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  // Normaliza removendo acentos, emojis, números, símbolos
  function clean(s) {
    return (s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Encontra o BLOCO da Tabla de Tallas (story-text que contém esse heading)
  function findTallasBlock() {
    var headings = document.querySelectorAll('.bs-story-heading, h1, h2, h3, h4, .bs-section-title, .bs-accordion-header');
    for (var i = 0; i < headings.length; i++) {
      var t = clean(headings[i].textContent);
      if (t.indexOf('tabla de tallas') !== -1 ||
          t.indexOf('tabla de tamanhos') !== -1 ||
          t.indexOf('tabla de tamanos') !== -1) {
        // Sobe até o bloco container do story
        var block = headings[i].closest('.bs-story-text, .bs-story-image, .bs-accordion-item, section, .bs-section');
        return block || headings[i].parentElement;
      }
    }
    return null;
  }

  function injectSection() {
    if (!isProductPage()) return;
    if (document.getElementById('bs-product-videos')) return;

    var anchor = findTallasBlock();
    if (!anchor) return;

    var wrapper = document.createElement('div');
    wrapper.id = 'bs-product-videos';
    wrapper.className = 'bs-product-videos-section';

    var headerHTML =
      '<div class="bs-pv-section-header">' +
        (SECTION_EYEBROW ? '<span class="bs-pv-section-eyebrow">— ' + SECTION_EYEBROW + ' —</span>' : '') +
        (SECTION_TITLE ? '<h2 class="bs-pv-section-title">' + SECTION_TITLE + '</h2>' : '') +
        (SECTION_SUBTITLE ? '<p class="bs-pv-section-subtitle">' + SECTION_SUBTITLE + '</p>' : '') +
      '</div>';

    var rowsHTML = VIDEOS.map(function (item, idx) { return buildVideoRow(item, idx); }).join('');

    wrapper.innerHTML =
      headerHTML +
      '<div class="bs-pv-rows">' + rowsHTML + '</div>';

    // Insere COMO SIBLING logo após o bloco da Tabla de Tallas
    if (anchor.parentNode) {
      anchor.parentNode.insertBefore(wrapper, anchor.nextSibling);
    }
  }

  function run() { try { injectSection(); } catch (e) { /* console.error(e); */ } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [300, 1000, 2500].forEach(function (ms) { setTimeout(run, ms); });

  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
